import { useSelector } from 'react-redux'
import {
  ScenarioSettingsPage,
  ScenarioSettingsPageConfig
} from 'src/redux/slices/analysis/consts'
import {
  makeSelectTracksBaseline,
  selectSettingsPageScenarioGroup,
  selectSortedScenarioNames
} from 'src/redux/slices/analysis/selectors'

import Typography from '@material-ui/core/Typography'

import ScenarioSettingsEndUses from './ScenarioSettingsEndUses'
import ScenarioSettingsFuels from './ScenarioSettingsFuels'
import ScenarioSettingsPV from './ScenarioSettingsPV'

type ScenarioSettingsProps = {
  scenarioName: string
}
const ScenarioSettings: React.FC<ScenarioSettingsProps> = ({ scenarioName }) => {
  const scenarioSettingsGroup = useSelector(selectSettingsPageScenarioGroup)
  const tracksBaseline = useSelector(
    makeSelectTracksBaseline({ scenarioName, settingsGroup: scenarioSettingsGroup }),
  )
  const baselineScenario = useSelector(selectSortedScenarioNames)[0]
  return !tracksBaseline || scenarioName === baselineScenario ? (
    <>
      {scenarioSettingsGroup === ScenarioSettingsPage.Fuels && (
        <ScenarioSettingsFuels scenarioName={scenarioName} />
      )}
      {scenarioSettingsGroup === ScenarioSettingsPage.EndUses && (
        <ScenarioSettingsEndUses scenarioName={scenarioName} />
      )}
      {scenarioSettingsGroup === ScenarioSettingsPage.PV && (
        <ScenarioSettingsPV scenarioName={scenarioName} />
      )}
    </>
  ) : (
    <Typography variant='overline'>
      This scenario is tracking the Baseline's
      {baselineScenario.toLowerCase() !== 'baseline' ? ` (${baselineScenario}) ` : ' '}
      {ScenarioSettingsPageConfig[scenarioSettingsGroup].label} settings.
    </Typography>
  )
}

export default ScenarioSettings
